// project-imports
import { getBlobRequest, postRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - BILLING ||============================== //

export async function handleBilling(action: APIAction) {
  switch (action.method) {
    case 'read-invoices':
      return postRequest('/billing/invoices', action.data, true);
    case 'download-invoice':
      return getBlobRequest(`/billing/invoices/${action.id}/pdf`);
    case 'download-credit-note':
      return getBlobRequest(`/billing/credit-notes/${action.id}/pdf`);
    case 'read-email-delivery-preference':
      return postRequest('/billing/email-delivery/preference', action.data, true);
    case 'update-email-delivery':
      return postRequest('/billing/email-delivery', action.data, true);
    default:
      console.info('[ApiManager > handleApiAction > handleBilling] - Unknown method');
      break;
  }
}
